// Translation file for SzakMintaTerve component
// Contains all UI text in Hungarian and English

export const SZAKMINTATERVE_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.2 és 1.9 A képzési programok kialakítása, jóváhagyása, folyamatos figyelemmel kísérése és rendszeres értékelése",
        pageTitle: "2. A szak mintatanterve",
        
        section1: {
            title: "2.1. A képzés URL-címe (link)"
        },
        
        section2: {
            title: "2.2. Aktuális mintatanterv tábla és tantárgytematikák (link)"
        },
        
        section3: {
            title: "2.3. Milyen változás történt a szakhoz kapcsolódóan a vizsgált félévben (több válasz is jelölhető)",
            noteLabel: "Megjegyzés (opcionális):",
        },

        section4: {
            title: "2.4. A képzés értékelése",
            titleA: "2.4.a Nem STEM képzési területhez kapcsolódó képzések (AACSB)",
            descriptionA: "Milyen módon értékeli és dokumentálja a képzésekhez kapcsolódó Learning Goals és Learning Objectives teljesülését, és milyen bizonyítékok támasztják alá az értékelési folyamat működését?",
            titleB: "2.4.b Műszaki, informatikai, agrár képzési területhez (STEM) kapcsolódó képzések (ABET)",
            descriptionB: "Milyen módon jelenik meg a képzési célok (PEO – Programme Educational Objectives) és tanulási kimenetek (SO – Student Outcomes) teljesülése? Vannak-e mérések ezekhez kapcsolódóan?"
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        esgTitle: "ESG 1.2 and 1.9 Design, Approval, Ongoing Monitoring and Periodic Review of Study Programmes",
        pageTitle: "2. Programme Curriculum",
        
        section1: {
            title: "2.1. Programme URL (link)"
        },
        
        section2: {
            title: "2.2. Current Sample Curriculum and Course Syllabi (link)"
        },
        
        section3: {
            title: "2.3. What changes occured in the program during the semester under review (multiple answers may be selected)",
            noteLabel: "Comments (optional):",
        },

        section4: {
            title: "2.4. Evaluation of the Programme",
            titleA: "2.4.a Non-STEM-related programmes (AACSB)",
            descriptionA: "In what ways is the achievement of programme-related Learning Goals (LGs) and Learning Objectives (LOs) assessed and documented, and what evidence supports the effectiveness of the assessment process?",
            titleB: "2.4.b Programmes related to science, technology, engineering, and mathematics (STEM) (ABET)",
            descriptionB: "In what way is the achievement of Programme Educational Objectives (PEOs) and Student Outcomes (SOs) demonstrated? Are there assessment mechanisms in place?"
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};